import authAxios from 'src/modules/shared/axios/authAxios';

export default class SubscriptionTierService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(
      `/subscription-tier/${id}`,
      body,
    );

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const response = await authAxios.delete(
      `/subscription-tier`,
      {
        params,
      },
    );

    return response.data;
  }

  static async unarchiveAll(ids) {
    const body = {
      ids,
    };

    const response = await authAxios.put(
      `/subscription-tier/unarchive`,
      body,
    );

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const response = await authAxios.post(
      `/subscription-tier`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const response = await authAxios.post(
      `/subscription-tier/import`,
      body,
    );

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(
      `/subscription-tier/${id}`,
    );

    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(
      `/subscription-tier`,
      {
        params,
      },
    );

    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      `/subscription-tier/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }
}
